import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Legal.css';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-section">
        <h1>Privacy Policy</h1>

        <section>
          <h2>Introduction</h2>
          <p>This Privacy Policy outlines how BreakMe.ai ("we," "us," or "our") collects, uses, and protects information related to its pen-testing and ethical hacking game (the "Game"). By using the Game, you agree to the practices described in this Privacy Policy. If you disagree with any part of this Privacy Policy, you must immediately stop interacting with the Game, its website, or any related channels.</p>
        </section>

        <section>
          <h2>1. Information We Collect</h2>
          <p>We collect minimal information to provide and improve the Game. This includes:</p>
          <ul>
            <li><strong>User-Provided Information:</strong> Communications and interactions within the Telegram interface of the Game.</li>
            <li><strong>Automatically Collected Information:</strong> Metadata and logs generated from your participation, such as timestamps and gameplay actions.</li>
          </ul>
        </section>

        <section>
          <h2>2. Use of Information</h2>
          <p>We use the information collected to:</p>
          <ul>
            <li>Facilitate gameplay and process interactions.</li>
            <li>Enhance and maintain the functionality of the Game.</li>
            <li>Enforce rules and prevent abuse.</li>
          </ul>
        </section>

        <section>
          <h2>3. Sharing of Information</h2>
          <p>We do not share your information with third parties except:</p>
          <ul>
            <li>As necessary to operate the Game and ensure its functionality.</li>
            <li>To comply with legal obligations, including sanctions compliance under OFAC (Office of Foreign Assets Control) regulations.</li>
            <li>With your explicit consent for additional features or purposes that may be introduced in the future.</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>We implement reasonable measures to protect your information from unauthorized access or misuse. However, no system is completely secure, and we cannot guarantee the absolute security of your data.</p>
        </section>

        <section>
          <h2>5. Sanctions Compliance</h2>
          <p>Users from the following OFAC-sanctioned countries are prohibited from participating in the Game: Cuba, Iran, North Korea, Syria, the Crimea region of Ukraine, and any other regions or countries designated by OFAC. By interacting with the Game, you affirm that you are not located in or a resident of any prohibited country, are not using a VPN or similar tool to mask your IP address, and are not acting on behalf of a sanctioned entity or individual.</p>
        </section>

        <section>
          <h2>6. Your Choices</h2>
          <p>You may choose to stop participating in the Game at any time. Contact us via our official Telegram channels if you have questions about your data.</p>
        </section>

        <section>
          <h2>7. Updates to This Policy</h2>
          <p>We may update this Privacy Policy periodically. Changes will take effect upon posting the updated policy.</p>
        </section>
      </div>
      
      <div className="legal-footer">
        <Link to="/" className="nes-btn is-primary">
          🎮 Return to Game
        </Link>
      </div>
    </div>
  );
} 